import React, { useState } from 'react';
import { useAPI } from '../../api';
import { useNavigate } from 'react-router-dom';
import { AccountInfo } from 'types';

interface AccountCreateNewContainerProps {
	onChanged: () => void;
}

const AccountCreateNewContainer = ({ onChanged }: AccountCreateNewContainerProps) => {
	const api = useAPI();
	const navigate = useNavigate();

	const [name, setName] = useState('');

	const createAccount = () => {
		if (!name.trim()) return alert('Account name is required');

		api.post<AccountInfo>('/api/accounts', { name })
		.then(json => { onChanged(); navigate(`/settings/accounts/${json.id}`); });
	};

	return (
		<div>
			<h2>Create New Account</h2>

			<hr />

			<table>
				<tbody>
					<tr>
						<td>Account Name</td>
						<td><input type="text" value={name} onChange={e => setName(e.target.value)} /></td>
					</tr>
					<tr>
						<td></td>
						<td><input type="button" value="Create Account" onClick={createAccount} /></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default AccountCreateNewContainer;
